import { AxiosError } from 'axios';

import ErrorComponent from '@/components/ui/custom/ErrorComponent';
import { ApiError } from '@/models/Errors';

type ApiErrorFallbackProps = {
  error: unknown;
  notFoundTitle: string;
  notFoundSubtitle: string;
};

export default function ApiErrorFallback({
  error,
  notFoundTitle,
  notFoundSubtitle,
}: ApiErrorFallbackProps) {
  if (error) {
    const { statusCode } = new ApiError(error as AxiosError<ApiError>);
    return <ErrorComponent statusCode={statusCode} />;
  }

  return (
    <ErrorComponent
      statusCode={404}
      errorTextTitle={notFoundTitle}
      errorTextSubTitle={notFoundSubtitle}
    />
  );
}
